const styles = {
  _marginX: "md:mx-32 mx-6",
  _raffleBtn:
    "flex items-center border-[3px] border-gold text-gold rounded-md font-semibold text-lg py-1 px-7 mt-9",
};

export default styles;
